import React, { useEffect, useState } from "react";
import { BaseButton, Spinner } from "../base";
import { fetchCustomerOrderAction } from "../../store/slices/order/action";
import { useAppDispatch, useAppSelector } from "../../store";
import { useParams } from "react-router-dom";
import Arrow from "../../assets/icons/ArrowDown.svg";
import OrderCard from "./OrderCard";
import { OperationType } from "../../enums/operation-type.enum";
import OrganisationLayout from "../organisation/layout/OrganisationLayout";
import CustomerTestResults from "../results";

const OrderDetailsIndex = () => {
  const { orderId } = useParams();
  const dispatch = useAppDispatch();
  const { orderDetails } = useAppSelector((state) => state.orderReducer);
  const { currentOrganisationAccount } = useAppSelector((state) => state.authReducer);
  const [showResult, setShowResult] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchOrderByUniqueId = async () => {
    setIsLoading(true);
    const { payload } = await dispatch(
      fetchCustomerOrderAction(orderId as string)
    );

    if (payload?.status === 200) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderByUniqueId();
  }, []);
  return (
    <OrganisationLayout>
      {isLoading ? (
        <Spinner spinnerText={""} styles={""} />
      ) : (
        <div className="sm:mx-8">
          <BaseButton
            text="Return to Dashboard"
            variant="neutral"
            hasLeftIcon={true}
            styles=" border-0 font-bold my-4 hover:border-0 px-4"
            to={`/dashboard`}
          >
            <img
              src={Arrow}
              alt="green dot icon"
              className="w-[15px] rotate-90 xl:w-[20px] mr-2"
            />
          </BaseButton>

          <OrderCard
            orderDetails={orderDetails}
            setShowResult={setShowResult}
            showResult={showResult}
          />

          {showResult &&
            orderDetails?.operationType === OperationType.LabTest && (
              <CustomerTestResults orderDetails={orderDetails} />
            )}
        </div>
      )}
    </OrganisationLayout>
  );
};

export default OrderDetailsIndex;
